import { Platform } from 'react-native';
import { rem } from 'design-system/values';
import { styles } from 'design-system/Text';
import createStyleSheets from 'utils/createStyleSheets';
import { TOOLBAR_PADDING_VERTICAL } from './config';
import { isDesktopOrWeb, isIOS, isWeb } from '../../../../constants';
export const MARGIN_HORIZONTAL = (() => rem(16))();
export const CLEAR_TOUCH_ZONE_WIDTH = (() => rem(44))();
export const CANCEL_MARGIN = (() => rem(12))();
export const SEARCH_BAR_HEIGHT = (() => rem(48))();
export const SEARCH_BAR_MARGIN_VERTICAL = rem(8);
export const SEARCH_BAR_TOTAL_HEIGHT = SEARCH_BAR_HEIGHT + 2 * SEARCH_BAR_MARGIN_VERTICAL;
export const SEARCH_TOTAL_SPENT_MAX_HEIGHT = rem(40);
export const SEARCH_TOTAL_SPENT_HEIGHT = (() => rem(39))();
const BORDER_RADIUS = (() => rem(12))();
const styleSet = createStyleSheets((colors) => ({
    header: {
        top: 0,
        left: 0,
        right: 0,
        position: 'absolute',
        backgroundColor: isDesktopOrWeb ? colors.background.dark : colors.cards.onDark,
        ...colors.shadows.headerAnimatedShadow,
    },
    searchBar: {
        flex: 1,
        height: SEARCH_BAR_HEIGHT,
        flexDirection: 'row',
        alignItems: 'center',
        borderRadius: BORDER_RADIUS,
        marginHorizontal: MARGIN_HORIZONTAL,
        marginVertical: SEARCH_BAR_MARGIN_VERTICAL,
        backgroundColor: colors.cards.onDark,
        cursor: 'text',
    },
    scrollViewContentContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingLeft: rem(16),
    },
    withSearchIcon: {
        paddingLeft: 0,
    },
    searchInput: {
        ...styles.TextThin_16,
        minWidth: rem(isWeb ? 250 : 140),
        // No line height from TextThin_16: on iOS it would put typed text below the
        // placeholder (see SettingsItem's textInput). The height keeps the bar's
        // layout on iOS.
        lineHeight: undefined,
        ...(isIOS && { height: rem(24) }),
        color: colors.text.primary,
        padding: 0,
        ...Platform.select({
            web: {
                outlineStyle: 'none',
                caretColor: colors.text.selection,
            },
        }),
    },
    closeIcon: {
        width: CLEAR_TOUCH_ZONE_WIDTH,
        height: SEARCH_BAR_HEIGHT,
        alignItems: 'center',
        justifyContent: 'center',
    },
    cancelContainer: {
        position: 'absolute',
        bottom: SEARCH_BAR_MARGIN_VERTICAL,
        height: SEARCH_BAR_HEIGHT,
        justifyContent: 'center',
    },
    toolbarWrap: {
        backgroundColor: colors.cards.onDark,
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
    },
    toolbarWrapInner: {
        borderTopWidth: 1,
        borderBottomWidth: 1,
        borderColor: colors.borders.divider,
        backgroundColor: colors.cards.onDark,
    },
    toolbarContainer: {
        flexDirection: 'row',
        paddingVertical: TOOLBAR_PADDING_VERTICAL,
        paddingHorizontal: rem(8),
        justifyContent: 'space-between',
        ...(isDesktopOrWeb && { alignItems: 'center' }),
    },
    noTransactionsMainContainer: {
        flex: 1,
        justifyContent: 'center',
    },
    noTransactionsContainer: {
        alignItems: 'center',
    },
    noTransactionsTitleContainer: {
        width: rem(220),
        marginBottom: rem(8),
    },
    noTransactionsTagContainer: {
        borderRadius: rem(20),
        backgroundColor: colors.cards.onDark,
    },
    noTransactionsTag: {
        height: rem(32),
        paddingHorizontal: rem(20),
        borderRadius: rem(20),
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
    row: {
        flexDirection: 'row',
    },
    searchHeaderRow: {
        flexDirection: 'row',
    },
    totalSpentContainer: {
        height: rem(40),
        paddingTop: rem(4),
        paddingHorizontal: rem(16),
        justifyContent: 'space-between',
    },
    keyboardWrapper: {
        flex: 1,
        backgroundColor: colors.cards.onDark,
    },
    hoverOnDark: {
        backgroundColor: colors.control.hoverOnDark,
        borderRadius: 20,
    },
    backChevron: {
        paddingLeft: rem(6),
    },
}));
export default styleSet;
